import devRuntimeConfig from '../environments/dev.config'
import localRuntimeConfig from '../environments/local.config'
import prodRuntimeConfig from '../environments/prod.config'
import staRuntimeConfig from '../environments/sta.config'
import RuntimeConfig from '../model/RuntimeConfig'

export default class RuntimeConfigStore {
  private allConfigs: { [configName: string]: RuntimeConfig }

  constructor() {
    this.allConfigs = {
      local: localRuntimeConfig,
      development: devRuntimeConfig,
      staging: staRuntimeConfig,
      production: prodRuntimeConfig,
    }
  }

  public getRuntimeConfig(configName: string): RuntimeConfig {
    const configFullName = this.findConfigFullName(configName)
    if (!configFullName) {
      throw this.createCannotFindRuntimeConfigError(configName)
    }
    return this.allConfigs[configFullName]
  }

  private findConfigFullName(configName: string): string {
    return (
      Object.keys(this.allConfigs).find((name) => {
        return name.startsWith(configName)
      }) || ''
    )
  }

  private createCannotFindRuntimeConfigError(configName: string) {
    const availableConfigNames = Object.keys(this.allConfigs)
    return new Error(
      `Cannot find runtime config with name that starts with '${configName}'.
      Avaialble config names are: ${availableConfigNames.join(', ')}.`,
    )
  }
}
